import React from "react";
import ReactDOM from "react-dom";

import Main from "./components/screens/Main";
import "./style.module.scss";

ReactDOM.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>,
  document.getElementById("root"),
);
